// import { WeighmentSitesAPI } from "api";
// import React, { useEffect, useState } from "react";
// import { Button, Card, Col, Form, Row } from "react-bootstrap";
// import { useFormContext } from "react-hook-form";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useFetchCustomers } from "../../../../hooks/useFetchCustomer";

// const BasicInformation = () => {
//   const {
//     register,
//     formState: { errors },
//   } = useFormContext();

//   const navigate = useNavigate();
//   const { state } = useLocation();

//   const [loading, setLoading] = useState(false);
//   const maxCharactersLength = 255;

//   const { data: customersData, isLoading: customerLoading } =
//     useFetchCustomers();

//   // console.log("customersData", customersData?.data?.data);

//   return (
//     <>
//       {loading ? (
//         <div className="d-flex py-3 justify-content-center align-items-center">
//           <Button variant="falcon-default" size="sm" className="fs-10">
//             Loading...
//           </Button>
//         </div>
//       ) : (
//         <Card.Body
//           className=""
//           style={{
//             height: `calc(100vh - 12.7rem)`,
//             overflow: "auto",
//             padding: "5px 20px",
//           }}
//         >
//           <Row className="gx-2 pb-2">
//             <Col md="6">
//               <Form.Group>
//                 <Form.Control
//                   type="text"
//                   placeholder="Name"
//                   title="Name"
//                   className="py-2 mb-1"
//                   {...register("name")}
//                   isInvalid={!!errors.name}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.name?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             <Col md="6">
//               <Form.Group>
//                 <Form.Select
//                   {...register("type")}
//                   title="Type"
//                   className="py-2 mb-1"
//                   isInvalid={!!errors.type}
//                 >
//                   <option value="">Select Type</option>
//                   <option value="Coupon">Coupon</option>
//                   <option value="BOGO">BOGO</option>
//                   <option value="FreeShipping">Free Shipping</option>
//                   <option value="Tiered">Tiered</option>
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">
//                   {errors.type?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md="6">
//               <Form.Group>
//                 <Form.Select
//                   {...register("discountType")}
//                   className="py-2 mb-1"
//                   title="Discount Type"
//                   isInvalid={!!errors.discountType}
//                 >
//                   <option value="">Select Discount Type</option>
//                   <option value="Percentage">Percentage</option>
//                   <option value="FixedAmount">Fixed Amount</option>
//                   <option value="FreeItem">Free Item</option>
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">
//                   {errors.discountType?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             <Col md="6">
//               <Form.Group>
//                 <Form.Control
//                   type="number"
//                   placeholder="Discount Value"
//                   title="Discount Value"
//                   className="py-2 mb-1"
//                   {...register("discountValue")}
//                   isInvalid={!!errors.discountValue}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.discountValue?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             <Col md="6">
//               <Form.Group>
//                 <Form.Control
//                   type="date"
//                   placeholder="Valid From"
//                   title="Valid From"
//                   className="py-2 mb-1"
//                   {...register("startDate")}
//                   isInvalid={!!errors.startDate}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.startDate?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             <Col md="6">
//               <Form.Group>
//                 <Form.Control
//                   type="date"
//                   placeholder="Valid To"
//                   title="Valid To"
//                   className="py-2 mb-1"
//                   {...register("endDate")}
//                   isInvalid={!!errors.endDate}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.endDate?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             <Col md="6">
//               <Form.Group>
//                 <Form.Select
//                   {...register("applicableTo")}
//                   className="py-2 mb-1"
//                   title="Applicable To"
//                   isInvalid={!!errors.applicableTo}
//                 >
//                   <option value="">Select Applicable To</option>
//                   <option value="Product">Product</option>
//                   <option value="Category">Category</option>
//                   <option value="Cart">Cart</option>
//                   <option value="Customer">Customer</option>
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">
//                   {errors.applicableTo?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             {/* <Col md="6">
//               <Form.Group>
//                 <Form.Select
//                   {...register("customerId")}
//                   className="py-2 mb-1"
//                   isInvalid={!!errors.customerId}
//                 >
//                   <option value="">Select Customer</option>
//                   {customersData?.data?.data?.map((customer) => (
//                     <option key={customer.id} value={Number(customer.id)}>
//                       {customer.firstName} {customer.lastName}
//                     </option>
//                   ))}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">
//                   {errors.customerId?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col> */}

//             {/* <Col md="6">
//               <Form.Select
//                 {...register("productId")}
//                 className="py-2 mb-1"
//                 isInvalid={!!errors.productId}
//               >
//                 <option value="">Select Product</option>
//               </Form.Select>
//               <Form.Control.Feedback type="invalid">
//                 {errors.productId?.message}
//               </Form.Control.Feedback>

//             </Col> */}

//             <Col md="6">
//               <Form.Group>
//                 <Form.Control
//                   type="number"
//                   placeholder="Usage Limit"
//                   title="Usage Limit"
//                   className="py-2 mb-1"
//                   {...register("usageLimit")}
//                   isInvalid={!!errors.usageLimit}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.usageLimit?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             <Col md="6">
//               <Form.Group>
//                 <Form.Control
//                   type="number"
//                   placeholder="Usage Per Customer"
//                   title="Usage Per Customer"
//                   className="py-2 mb-1"
//                   {...register("usagePerCustomer")}
//                   isInvalid={!!errors.usagePerCustomer}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.usagePerCustomer?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md="6">
//               <Form.Group>
//                 <Form.Control
//                   type="number"
//                   placeholder="Min Order Value"
//                   title="Min Order Value"
//                   className="py-2 mb-1"
//                   {...register("minOrderValue")}
//                   isInvalid={!!errors.minOrderValue}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.minOrderValue?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md="6">
//               <Form.Group>
//                 <Form.Select
//                   {...register("channel")}
//                   className="py-2 mb-1"
//                   title="Channel"
//                   isInvalid={!!errors.channel}
//                 >
//                   <option value="">Select Channel</option>
//                   <option value="Web">Web</option>
//                   <option value="MobileApp">Mobile App</option>
//                   <option value="POS">POS</option>
//                   <option value="MarketPlace">Market Place</option>
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">
//                   {errors.channel?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//           </Row>
//         </Card.Body>
//       )}
//     </>
//   );
// };

// export default BasicInformation;



import React, { useState } from "react";
import { Button, Card, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useFetchCustomers } from "../../../../hooks/useFetchCustomer";

const BasicInformation = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const navigate = useNavigate();
  const { state } = useLocation();

  const [loading, setLoading] = useState(false);

  const { data: customersData, isLoading: customerLoading } =
    useFetchCustomers();

  return (
    <>
      {loading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          style={{
            height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "10px 20px",
          }}
        >
          <Row className="gx-2 gy-2">
            {/* Name */}
            <Col md={6}>
              <FloatingLabel label="Name">
                <Form.Control
                  type="text"
                  placeholder="Name"
                  {...register("name")}
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* Type */}
            <Col md={6}>
              <FloatingLabel label="Type">
                <Form.Select
                  {...register("type")}
                  isInvalid={!!errors.type}
                >
                  <option value="">Select Type</option>
                  <option value="Coupon">Coupon</option>
                  <option value="BOGO">BOGO</option>
                  <option value="FreeShipping">Free Shipping</option>
                  <option value="Tiered">Tiered</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.type?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* Discount Type */}
            <Col md={6}>
              <FloatingLabel label="Discount Type">
                <Form.Select
                  {...register("discountType")}
                  isInvalid={!!errors.discountType}
                >
                  <option value="">Select Discount Type</option>
                  <option value="Percentage">Percentage</option>
                  <option value="FixedAmount">Fixed Amount</option>
                  <option value="FreeItem">Free Item</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.discountType?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* Discount Value */}
            <Col md={6}>
              <FloatingLabel label="Discount Value">
                <Form.Control
                  type="number"
                  placeholder="Discount Value"
                  {...register("discountValue")}
                  isInvalid={!!errors.discountValue}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.discountValue?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* Start Date */}
            <Col md={6}>
              <FloatingLabel label="Valid From">
                <Form.Control
                  type="date"
                  placeholder="Valid From"
                  {...register("startDate")}
                  isInvalid={!!errors.startDate}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.startDate?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* End Date */}
            <Col md={6}>
              <FloatingLabel label="Valid To">
                <Form.Control
                  type="date"
                  placeholder="Valid To"
                  {...register("endDate")}
                  isInvalid={!!errors.endDate}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.endDate?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* Applicable To */}
            <Col md={6}>
              <FloatingLabel label="Applicable To">
                <Form.Select
                  {...register("applicableTo")}
                  isInvalid={!!errors.applicableTo}
                >
                  <option value="">Select Applicable To</option>
                  <option value="Product">Product</option>
                  <option value="Category">Category</option>
                  <option value="Cart">Cart</option>
                  <option value="Customer">Customer</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.applicableTo?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* Usage Limit */}
            <Col md={6}>
              <FloatingLabel label="Usage Limit">
                <Form.Control
                  type="number"
                  placeholder="Usage Limit"
                  {...register("usageLimit")}
                  isInvalid={!!errors.usageLimit}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.usageLimit?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* Usage Per Customer */}
            <Col md={6}>
              <FloatingLabel label="Usage Per Customer">
                <Form.Control
                  type="number"
                  placeholder="Usage Per Customer"
                  {...register("usagePerCustomer")}
                  isInvalid={!!errors.usagePerCustomer}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.usagePerCustomer?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* Min Order Value */}
            <Col md={6}>
              <FloatingLabel label="Min Order Value">
                <Form.Control
                  type="number"
                  placeholder="Min Order Value"
                  {...register("minOrderValue")}
                  isInvalid={!!errors.minOrderValue}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.minOrderValue?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* Channel */}
            <Col md={6}>
              <FloatingLabel label="Channel">
                <Form.Select
                  {...register("channel")}
                  isInvalid={!!errors.channel}
                >
                  <option value="">Select Channel</option>
                  <option value="Web">Web</option>
                  <option value="MobileApp">Mobile App</option>
                  <option value="POS">POS</option>
                  <option value="MarketPlace">Market Place</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.channel?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>
          </Row>
        </Card.Body>
      )}
    </>
  );
};

export default BasicInformation;
